export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      portfolio: 'Réalisations',
      about: 'À propos',
      contact: 'Contact',
      quote: 'Demander un devis'
    },
    hero: {
      title: 'Votre Énergie,',
      titleHighlight: 'Notre Avenir',
      subtitle: 'Solutions solaires professionnelles pour particuliers et entreprises. Économisez sur vos factures tout en préservant la planète.',
      pictureTitle: 'Qualité garantie',
      pictureSubTitle: 'sur vos factures',
      energyExpert: 'Expert en énergie solaire depuis 2015',
      cta: 'Obtenir un devis gratuit',
      ctaSecondary: 'Découvrir nos services',
      stats: {
        projects: 'Projets réalisés',
        savings: 'Économies générées',
        satisfaction: 'Clients satisfaits',
        experience: "Années d'expérience"
      }
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Des solutions adaptées à chaque besoin énergétique',
      residential: {
        title: 'Installation Résidentielle',
        description: 'Panneaux solaires sur mesure pour votre maison. Réduisez vos factures et gagnez en autonomie énergétique.',
        features: ['Étude personnalisée', 'Installation certifiée', 'Garantie 25 ans', 'Suivi de production']
      },
      commercial: {
        title: 'Installation Commerciale',
        description: 'Solutions photovoltaïques pour entreprises et bâtiments professionnels. Optimisez vos coûts énergétiques.',
        features: ['Audit énergétique', 'Solutions grande échelle', 'ROI optimisé', 'Maintenance incluse']
      },
      maintenance: {
        title: 'Maintenance & SAV',
        description: 'Service après-vente réactif et maintenance préventive pour garantir la performance de votre installation.',
        features: ['Intervention rapide', 'Nettoyage panneaux', 'Contrôle annuel', 'Garantie pièces']
      },
      study: {
        title: 'Étude Gratuite - 100% Gratuit',
        description: 'Profitez d\'une analyse complète de votre potentiel solaire sans aucun engagement',
        features: ['Visite technique', 'Rapport détaillé', 'Simulation 3D', 'Devis transparent']
      }
    },
    portfolio: {
      title: 'Nos Réalisations',
      subtitle: 'Découvrez nos dernières installations solaires',
      viewDetails: 'Voir les détails',
      power: 'Puissance',
      savings: 'Économies/an',
      location: 'Localisation',
      type: 'Type',
      projects: [
        {
          title: 'Villa Méditerranéenne',
          location: 'Benslimane, Maroc',
          type: 'Résidentiel',
          power: '9.6 kWc',
          savings: '2,400€',
          description: 'Installation complète avec optimisation toiture sud'
        },
        {
          title: 'Entrepôt Logistique',
          location: 'Mohammedia, Maroc',
          type: 'Commercial',
          power: '150 kWc',
          savings: '38,000€',
          description: 'Centrale solaire en toiture avec autoconsommation'
        },
        {
          title: 'Résidence Lamtti',
          location: 'Casablanca, Maroc',
          type: 'Copropriété',
          power: '45 kWc',
          savings: '11,500€',
          description: 'Installation collective pour 24 logements'
        },
        {
          title: 'Maison Passive',
          location: 'Rabat, Maroc',
          type: 'Résidentiel',
          power: '6.3 kWc',
          savings: '1,800€',
          description: 'Intégration architecturale premium'
        }
      ]
    },
    about: {
      title: 'À Propos de Nous',
      subtitle: "L'excellence au service de votre transition énergétique",
      imageTitle: 'nous font confiance',
      imageSubTitle: 'Années d\'expertise',
      story: {
        title: 'Notre Histoire',
        content: "Fondée en 2015, AbdouBusiness s'est imposée comme référence dans l'installation de panneaux solaires. Notre engagement : vous accompagner vers l'indépendance énergétique avec des solutions de qualité supérieure."
      },
      values: {
        title: 'Nos Valeurs',
        quality: {
          title: 'Qualité',
          description: 'Matériaux premium et installations certifiées'
        },
        expertise: {
          title: 'Expertise',
          description: 'Équipe qualifiée avec formations continues'
        },
        trust: {
          title: 'Confiance',
          description: 'Transparence totale et engagement client'
        },
        eco: {
          title: 'Écologie',
          description: 'Solutions durables pour la planète'
        }
      },
      certifications: 'Certifications & Partenaires'
    },
    contact: {
      title: 'Contactez-Nous',
      subtitle: 'Notre équipe est à votre écoute',
      form: {
        name: 'Nom complet',
        email: 'Email',
        phone: 'Téléphone',
        message: 'Votre message',
        submit: 'Envoyer le message'
      },
      info: {
        address: 'Adresse',
        addressValue: '123 Avenue du Soleil, 20220 Casablanca',
        phone: 'Téléphone',
        phoneValue: '+212 6 23 45 67 89',
        email: 'Email',
        emailValue: 'contact@abdoubusiness.fr',
        hours: 'Horaires',
        hoursValue: 'Lun - Ven: 8h - 18h'
      },
      zone: 'Zone d\'intervention',
      zoneDesc: 'Nous intervenons dans toute la France métropolitaine'
    },
    quote: {
      title: 'Demande de Devis',
      subtitle: 'Obtenez votre estimation personnalisée en quelques clics',
      step: 'Étape',
      of: 'sur',
      steps: {
        type: {
          title: 'Type de projet',
          subtitle: 'Vous êtes...',
          residential: 'Particulier',
          residentialDesc: 'Installation pour ma maison',
          commercial: 'Professionnel',
          commercialDesc: 'Installation pour mon entreprise'
        },
        need: {
          title: 'Votre besoin',
          subtitle: 'Quel est votre objectif principal ?',
          newInstall: 'Nouvelle installation',
          newInstallDesc: 'Je souhaite installer des panneaux solaires',
          upgrade: 'Agrandissement',
          upgradeDesc: 'Je souhaite étendre mon installation existante',
          maintenance: 'Maintenance',
          maintenanceDesc: 'Je recherche un service de maintenance'
        },
        details: {
          title: 'Détails du projet',
          subtitle: 'Quelques informations sur votre projet',
          location: 'Code postal',
          locationPlaceholder: '75001',
          surface: 'Surface disponible (m²)',
          surfacePlaceholder: 'Ex: 50',
          consumption: 'Consommation annuelle (kWh)',
          consumptionPlaceholder: 'Ex: 8000',
          roofType: 'Type de toiture',
          roofTypes: {
            flat: 'Toit plat',
            pitched: 'Toit incliné',
            mixed: 'Mixte'
          }
        },
        contact: {
          title: 'Vos coordonnées',
          subtitle: 'Comment vous contacter ?',
          name: 'Nom complet',
          namePlaceholder: 'Jean Dupont',
          email: 'Email',
          emailPlaceholder: 'jean@exemple.fr',
          phone: 'Téléphone',
          phonePlaceholder: '06 12 34 56 78'
        }
      },
      next: 'Suivant',
      previous: 'Précédent',
      submit: 'Envoyer ma demande',
      success: 'Votre demande a été préparée !',
      successDesc: 'Cliquez sur le bouton pour ouvrir votre client email avec les informations pré-remplies.'
    },
    footer: {
      description: 'Expert en solutions solaires depuis 2015. Accompagnement personnalisé pour votre transition énergétique.',
      quickLinks: 'Liens rapides',
      whyChooseUs: 'Pourquoi nous choisir',
      expertise: 'Expertise solaire',
      freeQuote: 'Devis gratuit',
      tailorMade: 'Solutions sur mesure',
      support: 'Accompagnement complet',
      copyright: '© 2026 AbdouBusiness. Tous droits réservés.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'About',
      contact: 'Contact',
      quote: 'Get a Quote'
    },
    hero: {
      title: 'Your Energy,',
      titleHighlight: 'Our Future',
      subtitle: 'Professional solar solutions for homes and businesses. Save on your bills while protecting the planet.',
      pictureTitle: 'Guaranteed quality',
      pictureSubTitle: 'on your bills',
      energyExpert: 'Solar energy experts since 2015',
      cta: 'Get a Free Quote',
      ctaSecondary: 'Discover Our Services',
      stats: {
        projects: 'Projects Completed',
        savings: 'Savings Generated',
        satisfaction: 'Satisfied Clients',
        experience: 'Years Experience'
      }
    },
    services: {
      title: 'Our Services',
      subtitle: 'Solutions tailored to every energy need',
      residential: {
        title: 'Residential Installation',
        description: 'Custom solar panels for your home. Reduce your bills and gain energy independence.',
        features: ['Personalized study', 'Certified installation', '25-year warranty', 'Production monitoring']
      },
      commercial: {
        title: 'Commercial Installation',
        description: 'Photovoltaic solutions for businesses and commercial buildings. Optimize your energy costs.',
        features: ['Energy audit', 'Large-scale solutions', 'Optimized ROI', 'Maintenance included']
      },
      maintenance: {
        title: 'Maintenance & Support',
        description: 'Responsive after-sales service and preventive maintenance to ensure your installation performance.',
        features: ['Quick response', 'Panel cleaning', 'Annual check', 'Parts warranty']
      },
      study: {
        title: 'Free Assessment - 100% Free',
        description: 'Benefit from a complete assessment of your solar potential with no obligation',
        features: ['Technical visit', 'Detailed report', '3D simulation', 'Transparent quote']
      }
    },
    portfolio: {
      title: 'Our Projects',
      subtitle: 'Discover our latest solar installations',
      viewDetails: 'View Details',
      power: 'Power',
      savings: 'Savings/year',
      location: 'Location',
      type: 'Type',
      projects: [
        {
          title: 'Mediterranean Villa',
          location: 'Benslimane, Morocco',
          type: 'Residential',
          power: '9.6 kWp',
          savings: '€2,400',
          description: 'Complete installation with south roof optimization'
        },
        {
          title: 'Logistics Warehouse',
          location: 'Mohammedia, Morocco',
          type: 'Commercial',
          power: '150 kWp',
          savings: '€38,000',
          description: 'Rooftop solar plant with self-consumption'
        },
        {
          title: 'Lamtti Residence',
          location: 'Casablanca, Morocco',
          type: 'Co-ownership',
          power: '45 kWp',
          savings: '€11,500',
          description: 'Collective installation for 24 units'
        },
        {
          title: 'Passive House',
          location: 'Rabat, Morocco',
          type: 'Residential',
          power: '6.3 kWp',
          savings: '€1,800',
          description: 'Premium architectural integration'
        }
      ]
    },
    about: {
      title: 'About Us',
      subtitle: 'Excellence serving your energy transition',
      imageTitle: 'trust us',
      imageSubTitle: 'years of expertise',
      story: {
        title: 'Our Story',
        content: 'Founded in 2015, AbdouBusiness has established itself as a reference in solar panel installation. Our commitment: to support you towards energy independence with superior quality solutions.'
      },
      values: {
        title: 'Our Values',
        quality: {
          title: 'Quality',
          description: 'Premium materials and certified installations'
        },
        expertise: {
          title: 'Expertise',
          description: 'Qualified team with continuous training'
        },
        trust: {
          title: 'Trust',
          description: 'Total transparency and customer commitment'
        },
        eco: {
          title: 'Ecology',
          description: 'Sustainable solutions for the planet'
        }
      },
      certifications: 'Certifications & Partners'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Our team is here to help',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Your message',
        submit: 'Send Message'
      },
      info: {
        address: 'Address',
        addressValue: '123 Avenue du Soleil, 20220 Casablanca',
        phone: 'Phone',
        phoneValue: '+212 6 23 45 67 89',
        email: 'Email',
        emailValue: 'contact@abdoubusiness.fr',
        hours: 'Hours',
        hoursValue: 'Mon - Fri: 8am - 6pm'
      },
      zone: 'Service Area',
      zoneDesc: 'We operate throughout metropolitan France'
    },
    quote: {
      title: 'Quote Request',
      subtitle: 'Get your personalized estimate in a few clicks',
      step: 'Step',
      of: 'of',
      steps: {
        type: {
          title: 'Project Type',
          subtitle: 'You are...',
          residential: 'Individual',
          residentialDesc: 'Installation for my home',
          commercial: 'Business',
          commercialDesc: 'Installation for my company'
        },
        need: {
          title: 'Your Need',
          subtitle: 'What is your main goal?',
          newInstall: 'New Installation',
          newInstallDesc: 'I want to install solar panels',
          upgrade: 'Expansion',
          upgradeDesc: 'I want to expand my existing installation',
          maintenance: 'Maintenance',
          maintenanceDesc: 'I am looking for maintenance service'
        },
        details: {
          title: 'Project Details',
          subtitle: 'Some information about your project',
          location: 'Postal Code',
          locationPlaceholder: '75001',
          surface: 'Available surface (m²)',
          surfacePlaceholder: 'Ex: 50',
          consumption: 'Annual consumption (kWh)',
          consumptionPlaceholder: 'Ex: 8000',
          roofType: 'Roof Type',
          roofTypes: {
            flat: 'Flat roof',
            pitched: 'Pitched roof',
            mixed: 'Mixed'
          }
        },
        contact: {
          title: 'Your Contact Info',
          subtitle: 'How can we reach you?',
          name: 'Full Name',
          namePlaceholder: 'John Doe',
          email: 'Email',
          emailPlaceholder: 'john@example.com',
          phone: 'Phone',
          phonePlaceholder: '06 12 34 56 78'
        }
      },
      next: 'Next',
      previous: 'Previous',
      submit: 'Send My Request',
      success: 'Your request has been prepared!',
      successDesc: 'Click the button to open your email client with pre-filled information.'
    },
    footer: {
      description: 'Solar solutions expert since 2015. Personalized support for your energy transition.',
      quickLinks: 'Quick Links',
      whyChooseUs: 'Why Choose Us',
      expertise: 'Solar expertise',
      freeQuote: 'Free quote',
      tailorMade: 'Tailor-made Solutions',
      support: 'Full support',
      copyright: '© 2026 AbdouBusiness. All rights reserved.'
    }
  }
};
